<div class="modal-container">
  <header class="modal-header">
    <h3>{{ title() }}</h3>

    @if (showCloseButton()) {
    <button
      type="button"
      class="close-button"
      [attr.aria-label]="closeAriaLabel()"
      (click)="closeClicked.emit()"
    >
      ✕
    </button>
    }
  </header>

  <section class="modal-sub-header">
    <ng-content select="[dialogShellSubHeader]"></ng-content>
  </section>

  <main class="modal-body">
    <ng-content></ng-content>
  </main>

  @if (showFooter()) {
  <footer class="modal-footer">
    <div class="footer-start">
      <ng-content select="[dialogShellFooterStart]"></ng-content>
    </div>

    <div class="footer-actions">
      <ng-content select="[dialogShellActions]"></ng-content>

      @for (action of visibleActions(); track trackAction($index, action)) {
      <lib-button
        class="modal-action-button"
        [ngClass]="{
          'primary-button': action.variant === 'primary',
          'secondary-button': action.variant === 'secondary',
          'secondary-button-no-border': action.variant === 'secondary-no-border'
        }"
        [color]="action.color || 'var(--primary)'"
        [disabled]="action.disabled || false"
        [loading]="action.loading || false"
        [disabledBgColor]="action.disabledBgColor || 'var(--disabledGrey)'"
        [disabledTextColor]="action.disabledTextColor || 'var(--disabledText)'"
        (click)="onActionClick(action)"
      >
        {{ action.label }}
      </lib-button>
      }
    </div>
  </footer>
  }
</div>
